import { TextField, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  field: {
    minWidth: '15rem'
  }
}))

export default function DateField({ label, date, onChangeDate, helperText, min }) {
  const classes = useStyles();

  return (
    <TextField
      className={classes.field}
      label={label}
      value={date}
      helperText={helperText}
      onChange={e => onChangeDate(e.target.value)}
      InputLabelProps={{
        shrink: true
      }}
      inputProps={{
        type: "date",
        ...(min && { min })
      }}
    />
  )
}